function maskEmail(email: string): string {
  const [local, domain] = email.split('@');
  if (!local || !domain) return email;
  const firstChar = local[0];
  const maskLength = Math.max(local.length - 1, 3);
  const masked = firstChar + '*'.repeat(maskLength);
  return `${masked}@${domain}`;
}

export default maskEmail;
